
import { setGetTagsAction } from '../action';
import { getTags } from '../api/getTags';

export const setGetTags = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getTags(params);

            dispatch(setGetTagsAction(data));
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}